export const approvalData = [
    {
        type: 'Pendaftaran Kartu baru',
        id: '87165',
        nik: '350111234761',
        name: 'Nike Ardila',
        dateAssign: '1 Januari 2021',
        category: 'Lansia',
        document: [
            {
                docType: 'KTP',
                docUrl: 'https://koko.co.jpg'
            },
            {
                docType: 'KK',
                docUrl: 'https://koko.co.jpg'
            },
        ]

    },
    {
        type: 'Pendaftaran Kartu Rusak',
        id: '87995',
        nik: '350111234761',
        name: 'Nike Ardisa',
        dateAssign: '1 Januari 2021',
        category: 'Lansia',
        document: [
            {
                docType: 'KTP',
                docUrl: 'https://koko.co.jpg'
            },
            {
                docType: 'KK',
                docUrl: 'https://koko.co.jpg'
            },
        ]

    },
    {
        type: 'Pendaftaran Kartu baru',
        id: '876111',
        nik: '350111234761',
        name: 'Nike Ardilo',
        dateAssign: '1 Januari 2021',
        category: 'Veteran',
        document: [
            {
                docType: 'KTP',
                docUrl: 'https://koko.co.jpg'
            },
            {
                docType: 'KK',
                docUrl: 'https://koko.co.jpg'
            },
            {
                docType: 'Kartu Rusak',
                docUrl: 'https://koko.co.jpg'
            },
        ]

    }
]


export const BroadcastList = [
    {
        type: 'Kartu Baru',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Rusak',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Hilang',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Rusak',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Hilang',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Rusak',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        type: 'Kartu Hilang',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    }

]


export const DaftarPelangganDummyData = () => {
    let out = [];
    let i = 0;
    for (i = 0; i < 20; i++) {
        out.push({
            id: i + 1,
            title: 'Conan the Barbarian',
            summary: 'Orphaned boy Conan is enslaved after his village is destroyed...',
            year: '1982',
            image: 'http://conan.image.png'
        })
    }
    return out;
}
